import { memo } from "react";
import type { SvgProps } from "react-native-svg";
import Svg, { G, Mask, Path, Rect } from "react-native-svg";

const SvgGb = (props: SvgProps) => (
  <Svg width={22} height={16} fill="none" {...props}>
    <Rect width={22} height={16} fill="#fff" rx={2} />
    <Mask
      id="gb-flag"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <Rect width={22} height={16} fill="#fff" rx={2} />
    </Mask>
    <G mask="url(#gb-flag)">
      <Path fill="#0A17A7" d="M0 0h22v16H0z" />
      <Path
        fill="#fff"
        d="m24.179.235-7.423 5.098H22v5.334h-5.244l7.423 5.098-1.172 1.768-9.388-6.448v5.981H8.381v-5.981l-9.389 6.448-1.172-1.768 7.423-5.098H0V5.333h5.243L-2.18.235l1.172-1.768 9.389 6.447v-5.98h5.238v5.98l9.388-6.447z"
      />
      <Path
        stroke="#DB1F35"
        strokeLinecap="round"
        strokeWidth={0.667}
        d="M14.668 5.066 24.619-1.6M15.725 10.958l8.92 6.122M6.29 5.048l-9.306-6.385M7.299 10.884l-10.315 6.964"
      />
      <Path
        fill="#E6273E"
        fillRule="evenodd"
        d="M0 9.6h9.429V16h3.142V9.6H22V6.4h-9.429V0H9.43v6.4H0z"
        clipRule="evenodd"
      />
    </G>
  </Svg>
);
const Memo = memo(SvgGb);
export default Memo;
